import { Component, HostListener, Input, OnInit } from '@angular/core';
import { UploadFileList } from '@app/core/states/upload.actions';
import { RootBac } from '@app/library/models/bac.model';
import { Playlist } from '@app/library/models/playlist.model';
import { LibraryModalService } from '@app/library/services/library-modal.service';
import { Store } from '@ngxs/store';

import { LiveTrackingState } from './../../../../core/states/live-tracking.state';
import { DiskSpaceExceeded } from './../../../../core/states/upload.actions';

@Component({
  selector: 'rk-library-upload-dnd',
  templateUrl: './library-upload-dnd.component.html',
  styleUrls: ['./library-upload-dnd.component.scss'],
})
export class LibraryUploadDndComponent implements OnInit {
  @Input()
  box: RootBac;

  @Input()
  playlist: Playlist;

  isDraggingFile = false;
  isOverDropZone = false;

  constructor(
    private readonly store: Store,
    private readonly modalService: LibraryModalService,
  ) {}

  ngOnInit() {
    document.querySelector('body').appendChild(document.querySelector('.drop-zone'));
  }
  @HostListener('window:dragenter', ['$event'])
  onDragEnter(event: DragEvent) {
    if (!event.dataTransfer.items.length) {
      this.isDraggingFile = true;
    }
    // @ts-ignore
    const isFirefox = typeof InstallTrigger !== 'undefined';
    Object.values(event.dataTransfer.items).forEach((item: DataTransferItem) => {
      if (
        item.type !== 'application/x-dnd-track' &&
        (event.dataTransfer.effectAllowed === 'all' ||
          (isFirefox && event.dataTransfer.effectAllowed === 'uninitialized'))
      ) {
        this.isDraggingFile = true;

        return;
      }
      this.isDraggingFile = false;
    });
  }

  @HostListener('window:dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    if ((event.clientX === 0 && event.clientY === 0) || this.isOverDropZone) {
      this.isDraggingFile = false;
      this.isOverDropZone = false;
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDraggingFile = false;
    if (!this.store.selectSnapshot(LiveTrackingState.canUpload)) {
      this.store.dispatch(new DiskSpaceExceeded());

      return;
    }
    if (!this.playlist) {
      this.store.dispatch(new UploadFileList(event.dataTransfer.files, this.box));
    } else {
      this.modalService.playlistUploadBox(event.dataTransfer.files, this.playlist);
    }
  }
  onDragOver(event: DragEvent) {
    this.isOverDropZone = true;
    event.stopPropagation();
    event.preventDefault();
  }
}
